// extracted by mini-css-extract-plugin
export default {"base":"vp_vFgMf","label":"vp_n_Qkr"};